import { success, failure, request } from 'app/actions';
import * as actions from './reportGeneralPanelTRIActions';
import * as helpers from './reportGeneralPanelTRIHelpers';

const initialState = {
  filterTRI: [],
  cardDetailTRI: {},
  cardDetailStudentTRI: {},
  reportTRI: [],
  reportStudentTRI: [],
  reportStudentCicleTRI: {},
  reportPerformanceComparisonClass: [],
  questionDetailTRI: {},
  reportPerformanceComparisonSchool: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_ES_FILTER_TRI):
      return { ...state, filterTRI: initialState.filterTRI };
    case success(actions.GET_ES_FILTER_TRI):
      return { ...state, filterTRI: action.payload };
    case success(actions.GET_ES_TRI_DETAIL):
      return {
        ...state,
        cardDetailTRI: action.payload.content ? action.payload.content : initialState.cardDetailTRI,
      };
    case success(actions.GET_ES_TRI_STUDENT_DETAIL):
      return {
        ...state,
        cardDetailStudentTRI: action.payload.content
          ? action.payload.content
          : initialState.cardDetailStudentTRI,
      };
    case success(actions.GET_ES_REPORT_TRI):
      return {
        ...state,
        reportTRI: action.payload.content ? action.payload.content : initialState.reportTRI,
        bubbleChartCH: action.payload.content
          ? action.payload.content.bubbleChart.CHArea
          : initialState.reportTRI,
        bubbleChartCN: action.payload.content
          ? action.payload.content.bubbleChart.CNArea
          : initialState.reportTRI,
        bubbleChartLC: action.payload.content
          ? action.payload.content.bubbleChart.LCArea
          : initialState.reportTRI,
        bubbleChartMT: action.payload.content
          ? action.payload.content.bubbleChart.MTArea
          : initialState.reportTRI,
      };
    case success(actions.GET_ES_STUDENT_REPORT_TRI):
      return {
        ...state,
        reportStudentTRI: action.payload.content
          ? action.payload.content
          : initialState.reportStudentTRI,
      };
    case success(actions.GET_ES_EVALUATIONS_CICLE_STUDENT_TRI):
      return {
        ...state,
        reportStudentCicleTRI: action.payload.content
          ? action.payload.content
          : initialState.reportStudentCicleTRI,
      };
    case request(actions.GENERATE_REPORT_TRI):
    case request(actions.GENERATE_SCHOOL_REPORT_TRI):
      return {
        ...state,
        reportPerformanceComparisonClass: initialState.reportPerformanceComparisonClass,
        reportPerformanceComparisonSchool: initialState.reportPerformanceComparisonSchool,
      };
    case success(actions.GENERATE_REPORT_TRI):
      return {
        ...state,
        reportPerformanceComparisonClass: action.payload.content.performanceComparison,
        reportPerformanceComparisonSchool: initialState.reportPerformanceComparisonSchool,
      };
    case success(actions.GET_ES_QUESTION_DETAIL_TRI):
      return {
        ...state,
        questionDetailTRI: action.payload.content
          ? action.payload.content
          : initialState.questionDetailTRI,
      };
    case success(actions.GET_ES_SCHOOL_REPORT_TRI):
      return {
        ...state,
        reportTRI: action.payload.content ? action.payload.content : initialState.reportTRI,
        bubbleChartCH: action.payload.content
          ? action.payload.content.bubbleChart.CHArea
          : initialState.reportTRI,
        bubbleChartCN: action.payload.content
          ? action.payload.content.bubbleChart.CNArea
          : initialState.reportTRI,
        bubbleChartLC: action.payload.content
          ? action.payload.content.bubbleChart.LCArea
          : initialState.reportTRI,
        bubbleChartMT: action.payload.content
          ? action.payload.content.bubbleChart.MTArea
          : initialState.reportTRI,
      };
    case success(actions.GENERATE_SCHOOL_REPORT_TRI):
      return {
        ...state,
        reportPerformanceComparisonSchool: action.payload.content.performanceComparison,
        reportPerformanceComparisonClass: initialState.reportPerformanceComparisonClass,
      };
    case success(actions.GET_ES_TRI_SCHOOL_DETAIL):
      return {
        ...state,
        cardDetailTRI: action.payload.content ? action.payload.content : initialState.cardDetailTRI,
      };
    case success(actions.GET_ES_APPLICATION_REPORT_TRI):
      return {
        ...state,
        reportTRI: action.payload.content ? action.payload.content : initialState.reportTRI,
        bubbleChartCH: action.payload.content
          ? action.payload.content.bubbleChart.CHArea
          : initialState.reportTRI,
        bubbleChartCN: action.payload.content
          ? action.payload.content.bubbleChart.CNArea
          : initialState.reportTRI,
        bubbleChartLC: action.payload.content
          ? action.payload.content.bubbleChart.LCArea
          : initialState.reportTRI,
        bubbleChartMT: action.payload.content
          ? action.payload.content.bubbleChart.MTArea
          : initialState.reportTRI,
      };
    case success(actions.GET_ES_TRI_APPLICATION_DETAIL):
      return {
        ...state,
        cardDetailTRI: action.payload.content ? action.payload.content : initialState.cardDetailTRI,
      };
    default:
      return state;
  }
};

export default reducer;
